import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43d95fe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "checkmark",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 52 52"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "checkmark__circle",
  cx: "26",
  cy: "26",
  r: "25",
  fill: "none"
}, null, -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "checkmark__check",
  fill: "none",
  d: "M14.1 27.2l7.1 7.2 16.7-16.8"
}, null, -1 /* HOISTED */))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}